// extracted by mini-css-extract-plugin
export default {"requester-column":"TicketsTable_requester-column__lW75N"};